import { mlflowApiClient } from '@/shared/api/core/axios-instance';

import type { DeleteModelTagRequest } from '@/entities/registered-model/domain';

export const deleteModelTag = async (request: DeleteModelTagRequest): Promise<void> => {
  await mlflowApiClient.delete('/ajax-api/2.0/mlflow/registered-models/delete-tag', { data: request });
};
